<main>
  <section class="desktop">
    <div class="esquerda">
      <div class="content-esquerda">
        <span>Nome Completo Aluno</span>
        <span>{{aluno ? (aluno.nome ? aluno.nome: 'Não informado') : 'Não informado'}}</span>
      </div>
      <div class="content-esquerda">
        <span>Data de nascimento</span>
        <span>{{aluno ? (aluno.dataNascimento ? (aluno.dataNascimento | date: 'dd/MM/yyyy') : 'Não informado') : 'Não informado'}}</span>
      </div>
      <div class="content-esquerda">
        <span>Gênero</span>
        <span>{{aluno ? (aluno.genero ? aluno.genero : 'Não informado') : 'Não informado'}}</span>
      </div>
    </div>
    <div class="direita">
      <div class="content-direita">
        <span>Endereço</span>
        <span>{{aluno ? (aluno.endereco ? aluno.endereco : 'Não informado') : 'Não informado'}}</span>
      </div>
      <div class="content-direita">
        <span>Complemento</span>
        <span>{{aluno ? (aluno.complemento ? aluno.complemento : 'Não informado') : 'Não informado'}}</span>
      </div>
      <div class="content-direita">
        <span>Número</span>
        <span>{{aluno ? (aluno.numero ? aluno.numero : 'Não informado') : 'Não informado'}}</span>
      </div>
      <div class="content-direita">
        <span>Bairro</span>
        <span>{{aluno ? (aluno.bairro ? aluno.bairro : 'Não informado') : 'Não informado'}}</span>
      </div>
      <div class="content-direita">
        <span>Cidade</span>
        <span>{{aluno ? (aluno.cidade ? aluno.cidade : 'Não informado') : 'Não informado'}}</span>
      </div>
      <div class="content-direita">
        <span>Estado</span>
        <span>{{aluno ? (aluno.estado ? aluno.estado : 'Não informado') : 'Não informado'}}</span>
      </div>
    </div>
  </section>
</main>
